'use strict';

var $ = require('jquery');
import {debounce} from '../components/custom-lodash';

var $window = $(window);

function lazyloadcss() {
    $('.lazyload-container').each(function () {
        // Checking window size
        var screensize = $window.width();

        // Getting all the lazyload images
        var $lazycontainer = $(this);

        // Getting all the cuton atributes, for all viewports
        var custommobile = $lazycontainer.attr('lazyload-custom-mobile');
        var customtablet = $lazycontainer.attr('lazyload-custom-tablet');
        var customdesktop = $lazycontainer.attr('lazyload-custom-desktop');

        // One value for each viewport
        if (screensize < 768) {
            // if value exist
            if (custommobile) {
                // split after X
                var custommobile_array = custommobile.split('x');
                // check if is valid
                if (custommobile_array.length >= 2) {
                    // Get Heigh and Width
                    var custommobile_array_H = custommobile_array[1];
                    var custommobile_array_W = custommobile_array[0];
                    var custommobile_H_number = Number(custommobile_array_H);
                    var custommobile_W_number = Number(custommobile_array_W);
                    // Calculation for padding botton
                    var custommobile_value = (custommobile_H_number / custommobile_W_number) * 100;
                    var custommobile_value_css = custommobile_value + '%';
                    // Apply CSS
                    $lazycontainer.css('padding-bottom', custommobile_value_css);
                }
            } else {
                $lazycontainer.removeAttr('style');
            }
        } else if (screensize < 1024) {
            // if value exist
            if (customtablet) {
                // split after X
                var customtablet_array = customtablet.split('x');
                // check if is valid
                if (customtablet_array.length >= 2) {
                    // Get Heigh and Width
                    var customtablet_array_H = customtablet_array[1];
                    var customtablete_array_W = customtablet_array[0];
                    var customtablet_H_number = Number(customtablet_array_H);
                    var customtablet_W_number = Number(customtablete_array_W);
                    // Calculation for padding botton
                    var customtablet_value = (customtablet_H_number / customtablet_W_number) * 100;
                    var customtablet_value_css = customtablet_value + '%';
                    // Apply CSS
                    $lazycontainer.css('padding-bottom', customtablet_value_css);
                }
            } else {
                $lazycontainer.removeAttr('style');
            }
        } else {
            // if value exist
            if (customdesktop) {
                // split after X
                var customdesktop_array = customdesktop.split('x');
                // check if is valid
                if (customdesktop_array.length >= 2) {
                    // Get Heigh and Width
                    var customdesktop_array_H = customdesktop_array[1];
                    var customdesktop_array_W = customdesktop_array[0];
                    var customdesktop_H_number = Number(customdesktop_array_H);
                    var customdesktop_W_number = Number(customdesktop_array_W);
                    // Calculation for padding botton
                    var customdesktop_value = (customdesktop_H_number / customdesktop_W_number) * 100;
                    var customdesktop_value_css = customdesktop_value + '%';
                    // Apply CSS
                    $lazycontainer.css('padding-bottom', customdesktop_value_css);
                }
            } else {
                $lazycontainer.removeAttr('style');
            }
        }
    });
}

// Also run in resize
$window.on('resize orientationchange', debounce(lazyloadcss, 10));

module.exports = {
    init: function () {
        lazyloadcss();
    }
};
